import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Estudiantes from "./views/Estudiantes.vue";
import Facilitadores from "./views/Facilitadores.vue";
import Dashboard from "./views/Dashboard.vue";
import Niveles from "./views/Niveles.vue";
import store from './store';
import requestApi from './resources/request';
import Home from './views/Home.vue'
import Inscripcion from './views/inscripciones/InscripcionesPublicas.vue'
import DashboardInscripciones from './views/inscripciones/DashboardInscripciones.vue'
import Catedras from './views/catedras/Index.vue'
import Test from './views/Test.vue'

Vue.use(Router);

/*const permit = (permissionName) => {
  var Permissions = store.getters['auth/permissions'];
  return Permissions.indexOf(permissionName) !== -1;
};*/

const routes =  new Router({
  linkExactActiveClass: "active",
  mode:'history',
  routes: [
    {
      path: "/",
      name: "home",
      meta:{ auth: false, permission: 'landing'},
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/test",
      name: "test",
      meta:{ auth: false, permission: 'landing'},
      components: {
        header: AppHeader,
        default: Test,
        footer: AppFooter
      }
    },
    {
      path: "/dashboardinscripciones",
      name: "dashboardinscripciones",
      meta:{ auth: false, permission: 'landing'},
      components: {
        header: AppHeader,
        default: DashboardInscripciones,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      meta:{ auth: false, permission: 'landing'},
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/inscripcion",
      name: "inscripcionespublicas",
      meta:{ auth: false, permission: 'landing'},
      components: {
        header: AppHeader,
        default: Inscripcion,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      meta:{ auth: false, permission: 'landing'},
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      meta:{ auth: false, permission: 'landing'},
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      meta:{ auth: false, permission: 'landing'},
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      meta:{ auth: true},
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/estudiantes",
      meta:{ auth: true},
      name: "estudiantes",
      components: {
        header: AppHeader,
        default: Estudiantes,
        footer: AppFooter
      }
    },
    {
      path: "/catedras",
      meta:{ auth: true},
      name: "catedras",
      components: {
        header: AppHeader,
        default: Catedras,
        footer: AppFooter
      }
    },
    {
      path: "/facilitadores",
      meta:{ auth: true},
      name: "facilitadores",
      components: {
        header: AppHeader,
        default: Facilitadores,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta:{ auth: true},
      components: {
        header: AppHeader,
        default: Dashboard,
        footer: AppFooter
      }
    },
    {
      path: "/niveles",
      name: "niveles",
      meta:{ auth: true},
      components: {
        header: AppHeader,
        default: Niveles,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

routes.beforeEach((to, from, next)=>{
  if(to.meta.permission === 'landing'){
    next();
  }
  else{
    if(to.meta.auth != undefined){
      if (store.getters['auth/authenticated']) {
        if (!to.meta.auth) {
          next({ path: '/' })
        }
        else{
            requestApi.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['auth/token'];
            next();          
        }
      }
      else{        
        next({path:'login'});
      } 
    }   
    else{
      next({ path: '/404' })
    }
  }

});

export default routes;